module.exports = __webpack_public_path__ + "static/media/team-hania.88afd28a.jpg";